import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-sale-attribute-section',
    templateUrl: './property-sale-attribute-section.component.html',
    styleUrls: ['./property-sale-attribute-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertySaleAttributeSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertySaleAttributeSectionForm')
    propertySaleAttributeSectionForm: NgForm;

    constructor(
        public draftFacade: DraftFacade,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.formHelperService.validate(
            this.propertySaleAttributeSectionForm
        );
        return this.propertySaleAttributeSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertySaleAttributeSectionForm.form.dirty;
    }
}